<template>
 <el-autocomplete ref="elAutocomplete" v-model.trim="email" :trigger-on-focus="false" :fetch-suggestions="querySearch" @select="handleSelect" v-bind="$attrs" v-on="$listeners">
    <template v-for="(slot, key) in $scopedSlots" :slot="key" slot-scope="scope">
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
 </el-autocomplete>
</template>
<script>
export default {
  name: "AutocompeleteEmail",
  props: {
    value: {
      type: String,
      default: ""
    },
    // 常见邮箱域名
    domains: {
      type: Array,
      default: () => {
        return ["gmail.com", "qq.com", "163.com", "outlook.com", "yahoo.com", "sina.com", "aliyun.com"]
      }
    }
  },
  computed: {
    email: {
      get() {
        return this.value // 从 props 获取外部传入的值
      },
      set(newValue) {
        this.$emit("input", newValue) // 将内部的值传递到外部
      }
    }
  },
  methods: { 
    // 根据输入内容匹配邮箱域名
    querySearch(queryString, cb) {
      let results = []

      if (!queryString) {
        cb(results)
        return
      }
    
      const atIndex = queryString.indexOf("@")

      if (atIndex !== -1) {
        const prefix = queryString.slice(0, atIndex + 1) // 获取@之前的部分
        const inputDomain = queryString.slice(atIndex + 1) // 获取用户输入的域名部分

        // 匹配域名
        results = this.domains
          .filter(domain => domain.startsWith(inputDomain)) // 过滤出匹配的域名
          .map(domain => ({ value: prefix + domain })) // 拼接成完整的邮箱地址

        // 如果用户输入的域名不在列表中，允许自定义输入
        if (results.length === 0) {
          results.push({ value: queryString })
        }
      }

      // 调用回调函数返回匹配结果
      cb(results)

      // 强制展示选项  修复清空选项后 再输入@键 不会显示选项的bug
      if (results.length > 0 && this.$refs.elAutocomplete) {
        this.$refs.elAutocomplete.activated = true
      }
    },

    // 用户选择补全项时的回调
    handleSelect(item) {
      this.email = item.value // 将选中的值赋给输入框
      this.$emit("complete")
    }

  }
}
</script>